/*

Suresh  10/26/2022 3075154998  Added outlined icons and  Class Name for Table
Ashraf  10/30/2022 3075154998  fixed table pagination issue
Lalitha 11/01/2022 3075154998  TablePagination bug Fix
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Raghu 11/30/2022 3075154998 Table footer styling fixes
*/

import React, {createRef, useState} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../../../components/TableIcons';
import DeleteTableRecordPopup from '../../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {TablePagination} from '@material-ui/core';
import {defaultRows, tablePageRows} from '../../../../../../constants/ReusableTablePagination';

export default function ConditionTable({
  recordData,
  setRecordData,
  conditionData,
  setConditionData,
  setIsConditionEditMode,
  setConditionRowData,
  setConditionCode,
}) {
  const [rows, setRows] = useState(defaultRows);
  const columns = [
    {
      title: 'Seq No',
      field: 'seqNum',
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        maxWidth: 200,
        textAlign: 'center',
      },
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        recordData[rowData.tableData.id].seqNum = rowSeqNo;
        return rowSeqNo;
      },
    },
    {
      title: 'Description',
      field: 'description',
    },
    {
      title: 'Begin',
      field: 'startPosition',
    },
    {
      title: 'End',
      field: 'endPosition',
    },
    {
      title: 'Field',
      field: 'fieldName',
    },
    {
      title: 'Type',
      field: 'fieldType',
    },
    {
      title: 'Format Spec',
      field: 'displayFormat',
    },
    {
      title: 'Group',
      field: 'groupName',
    },
  ];

  const tableRef = createRef();
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const tableDataCondition = recordData ?
    recordData?.map((item, i) => ({
      ...item,
      id: i,
    })) :
    [];
  const handleConditionEdit = (rowData) => {
    setIsConditionEditMode(true);
    setConditionRowData(rowData);
  };
  const handleDelete = (rowData) => {
    setIsDelete(true);
    setDeleteData(rowData);
  };
  const handleClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    setTimeout(() => {
      const data = [...recordData];
      const newData = data.filter(
        (row, i) =>
          row.seqNum !== deleteData.seqNum,
        // row.srcField !== deleteData.srcField ||
        // row?.operator?.id !== deleteData?.operator?.id ||
        // row.dateFormat !== deleteData.dateFormat
      );
      setRecordData(newData);
    }, 1000);
    setIsDelete(false);
  };
  return (
    <div>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Condition"
        value={`Are you sure you want to delete this condition?`}
        handleSubmit={handleSubmit}
      />
      <div className="custom-table global-field-table">
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          data={tableDataCondition}
          options={{
            search: false,
            toolbar: false,
            pageSize: rows,
            pageSizeOptions: tablePageRows,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          components={{
            Pagination: (props) => (
              <div className="global-field-table-footer">
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              </div>
            )}}
          actions={[
            {
              icon: () => (
                <>
                  <EditOutlinedIcon />
                </>
              ),
              tooltip: 'Edit',
              onClick: (event, rowData) => {
                handleConditionEdit(rowData);
                setConditionCode(rowData.id);
              },
            },
            {
              icon: () => (
                <>
                  <DeleteOutlineOutlinedIcon />
                </>
              ),
              tooltip: 'Delete',
              onClick: (event, rowData) => {
                handleDelete(rowData);
                setIsDelete(true);
              },
            },
          ]}
        />
      </div>
    </div>
  );
}
